export default {
    OrganizationType: {
        Organization: 'Organization',
        BusinessHousehold: 'Business Household'
    },
    AddBusinessHousehold: 'Add business household',
    EditBusinessHousehold: 'Edit business household',
    IdentificationNumber: 'Personal identification number',
    InvoiceReceivedEmail: 'Invoice receiving email:',
    HouseholdNote: 'Required to enter one of the two information "Personal identification number" or "Tax code"',
    SelectCompany: 'Select company:',
    AddCompany: 'Add company',
    EditCompany: 'Edit company',
    AddCustomer: 'Add customer',
    TaxCode: 'Tax Code',
    TaxCodeOrIdentification: 'Tax Code/Personal Identification Number',
    TitleTaxCode: 'Tax Code',
    TextNameHouseholdLicense: 'Household Business Name',
    NameOrganization: 'Unit name',
    NameCustomer: 'Customer name',
    FullName: 'Full name',
    Address: 'Address',
    Tel: 'Phone number',
    Website: 'Website',
    CreateInvoiceEmail: 'Invoice receiving email',
    Email: 'Email',
    PaymentInfoNotRequired: 'Payment information (optional)',
    BankName: 'Bank name',
    BankAccountNo: 'Account number',
    BankBranch: 'Branch',
    Cancel: 'Cancel',
    Complete: 'Complete',
    CreatedOrganization: 'Add branch, department',
    CreatedCustomer: 'Add customer',
    EditOrganization: 'Edit branch, department',
    EditCustomer: 'Edit customer',
    SuccessAddOrganization: 'Create successfully',
    SuccessEditOrganization: 'Edit successfully',
    ManagementOrganization: 'Branch, department',
    ManagementCustomer: 'Customer management',
    SelectOrganization: 'Select unit',
    SelectWorkingOrganization: 'Select working unit',
    ClickToCopyInvRevEmail: 'Click to copy invoice receiving email',
    DeclareOrganization: 'Declare customer',
    Save: 'Save',
    WarningDataChange: '<span class="title-toast-message">The data has not been saved.</span><br>Are you sure you want to cancel?',
    Edit: 'Edit',
    Delete: 'Delete',
    ErrorDeleteWorking: 'The working unit could not be deleted. Please check back.',
    ErrorDeleteWorked: 'has incurred data. You need to move all Invoices/Customs Declarations before deleting.',
    ErrorDeleteCompanyHasChildren: 'Can not be delete units that already have branch/department ',
    ErrorDeleteBranchHasChildren: 'Can not be delete units that already have department ',
    ComfirmDelete: 'Are you sure you want to delete',
    DeleteSuccess: 'Delete successfully',
    PlaceholderSearch: 'Enter Name, Tax code, Personal identification number, Invoice email to search',
    PlaceholderSearchCombobox: 'the program is showing tax code input to search',
    Customer: 'Customer',
    InvRevEmail: 'Invoice receiving email',
    InvoiceCount: 'Input invoice',
    OutInvoiceCount: 'Output invoice',
    DeclarationCount: 'Customs declaration',
    LastActive: 'Last login',
    GuideOrganization: 'Select units to view<br>invoice',
    OrganizationInfo: 'Unit information',
    NameCompany: 'Company name',
    NameCompanyLicense: 'Company name (according to business license)',
    NameHouseholdLicense: 'Business household name (according to business license)',
    NameHouseholdOrCompanyLicense: 'Organization/Business household name (according to business license)',
    AddressCompany: 'Address',
    AddressCompanyLicense: 'Address (according to business license)',
    AcceptInvalid: 'Accept multiple valid names, addresses',
    ChangeUserUsing: 'Change user',
    ChangeUserToDefault: fullname => `Using account <strong> ${fullname} </strong>`,
    KindChange: 'Type',
    InfoAccept: 'Names/addresses are accepted',
    StartDate: 'Start date',
    EndDate: 'End date',
    PersonAccept: 'Acceptor',
    SubEmail: '@meinvoice.vn',
    HistoryChange: 'History of changing business license',
    InfoBonusAccept: 'Acceptable information added',
    AddRow: 'Add row',
    CreateEmail: 'Create an email to receive invoices',
    InfoCompany: 'Unit information',
    NotAddressAccept: 'No name/address is accepted',
    TextNote: "Declare name/address information based on changes to the organization's business license",
    ErrorDateChangeHistories: 'The validity interval of each line should not overlap',
    ViewAll: 'View all',
    AddBranch: 'Add branch',
    EditBranch: 'Edit branch',
    AddDepartment: 'Add department',
    EditDepartment: 'Edit department',
    OrganizationStructure: 'Organizational structure',
    DepartmentName: 'Name of department',
    BranchName: 'Branch name',
    BranchOrDepartmentName: 'Branch name/department',
    EmailTakeInvoice: 'Your invoice receiving email is:',
    GiveOrForwardEmailToHandle: 'Send or forward the e-invoice email to this email, the system will automatically process the invoice.',
    TimeEffect: 'The validity time',
    OrgDetail: {
        LogDeleteInfo: {
            FirstText: 'Delete acceptable name/address information of',
            SecondText: 'effective from date',
            ThirdText: 'to date'
        },
        LogEditInfo: {
            FirstText: 'Edit end date/acceptable address information of',
            SecondText: 'from',
            ThirdText: 'to'
        },
        CopyEmailSuccess: 'Email copied successfully'
    },
    NoData: 'No data',
    TC: 'Tax Code',
    OrgWidget: {
        AlertAddFirstBranchHaveDepartment: 'The program will transfer tax code, address and departments from the company to the branch.',
        AlertAddFirstBranchNoDepartment: 'The program will transfer the  invoice receiving email, tax code/personal identification number and incurrences (if any) from the company to the branch.',
        AlertAddFirstBranchNoDepartment2: 'The program will transfer the  invoice receiving email, tax code and incurrences (if any) from the company to the branch.',
        AlertAddFirstDepartmentFromCompany: 'The program will transfer the invoice receiving email and incurrences (if any) from the company to the department.',
        AlertAddFirstDepartmentFromBranch: 'The program will transfer the invoice receiving email and incurrences (if any) from the branch to the department.',
        CreateBranchSuccess: 'Create a branch successfully',
        CreateDepartmentSuccess: 'Create a department successfully',
        DeleteCompany: 'Delete company',
        DeleteBranch: 'Delete branch',
        DeleteDepartment: 'Delete department',
        DeletedCompanySuccess: 'Company successfully deleted',
        DeletedBranchSuccess: 'Branch successfully deleted',
        DeletedDepartmentSuccess: 'Department successfully deleted',
        WannaDeleteCompany: 'You want to delete the company',
        WannaDeleteBranch: 'You want to delete the branch',
        WannaDeleteDepartment: 'You want to delete the department',
        PrefixCompany: name => `<span class='font-bold'>Company ${name}</span>`,
        PrefixBranch: name => `Branch ${name}</span>`,
        PrefixDepartment: name => `Department ${name}</span>`,
        ConfirmDeleteWithChild: {
            FirstText: 'Are you sure you want to delete',
            SecondText: 'and the respective subordinate units?'
        },
        ConfirmDeleteWithNoChild: {
            FirstText: 'Are you sure you want to delete',
            SecondText: '?'
        }
    },
    OrgStructure: {
        DeclareInfo: "Declare name/address information based on changes to the organization's business license"
    },
    FoundedDate: 'Effective date',
    TooltipFoundedDate: 'Effective date of the start of the name, address under the business license',
    ChangeEmailReceive: 'Change email receive',
    EmailReceiveText: `Your invoice receiving email is:`,
    EmailReceiveTextNote: `After changing, you will not receive invoices sent to the <span class='font-bold'>old</span> email address. Please ask the seller to send the email to the <span class='font-bold'>new</span> email address to avoid losing invoices.`,
    EmailNew: 'New email address',
    EmailOld: 'Old email address',
    UpdateEmailReceiveSuccess: 'Update email address successfully',
    EmailNewSameAsOldTooltip: 'New email address must be different from old email address',
    EmailNewRequiredMsg: 'New email address is required',
    ChangeEmailReceiveFailed: 'Change email receive failed',
    ChangeEmailFailedTitle: 'Change email receive failed',
    TextGuideDetail: {
        Text0: 'If a business household has ',
        Text1: 'If a company has ',
        Text2: 'many branches, departments ',
        Text3: 'receive invoices, to centrally manage invoices, you can add branches/departments belonging to the company.',
        Text4: 'receive invoices, to centrally manage invoices, you can add branches/departments belonging to the business house hold.'
    },
    PersonalIdRequired: 'Personal identification number is required',
    ChangeTypeOrganizationNote: 'Changing the entity type from "Organization" to "Business Household" allows you to declare additional Personal identification number information for more accurate invoice verification. After changing the entity type, you cannot change it back. Please ensure you select the appropriate entity type.',
    NotSupportChange: 'Changing the entity type from "Business Household" to "Organization" is not supported to avoid affecting the results of previous invoice verifications. Please ensure you select the appropriate entity type from the beginning when creating a Company/Department/Branch.',
    NotTheSameIdentity: 'The Personal identification number and Tax code do not belong to the same entity. Are you sure you want to save?',
    UpdateCCCDBtn: 'Update identification number on organizational structure',
    UpdateCCCDPopup: {
        Title: 'Update identification number on organizational structure',
        NotificationSuccess: identificationText => `You have ${identificationText} and can log into the software.`,
        IdentificationText: identification => `successfully updated identification number ${identification}`,
        NotificationInstruction: orgText =>
            `Next, you need to update identification number to the ${orgText} so that the invoice verification results are accurate. Select unit:`,
        ConfirmationText: 'I confirm and take full responsibility for updating identification number on the organizational structure',
        Buttons: {
            Skip: 'Skip',
            UpdateNow: 'Update now'
        },
        Messages: {
            UpdateSuccess: 'Successfully updated identification number on organizational structure',
            UpdateError: 'An error occurred while updating identification number. Please try again.'
        }
    },
    SelectToUpdate: 'Select to update identification number instead of Tax Code',
    PopupDeleteIdentificationNumber: 'Delete citizen identification number',
    ContentPopupDeleteIdentificationNumber: 'Deleting the citizen identification number may affect your data in the software. Do you want to continue saving?',
    UpdateCCCDTitle: 'Update citizen identification number',
    CCCDChangeMessage: 'Do you want to update the citizen identification number?',
    ChangeTo: 'replace CCCD',
    CCCDImpact1: 'Updating the citizen identification number will <span style="font-weight: 700;color: #FF9F0E;">affect your organizational structure data</span>. Please click <span style="font-weight: 700;color: #212529;">Confirm</span> to proceed with the update.',
    CCCDImpact2: 'Affected data may include: Invoice checking results, Tax Authority connection, Invoice transfer settings from email source, Organizational structure, ...',
    CCCDImpact3: 'After completing the update, data management in the software will use the new citizen identification number.',
    ViewGuide: 'View guide',
    Confirm: 'Confirm',
    ToastUpdateSuccess: 'Organizational structure data update completed',
    DoConfirm: 'Please check "I confirm and take full responsibility for updating identification number on the organizational structure" before clicking <strong> Update now</strong>.',
    SelectAtLeastItem: 'Please select at least 1 organizational information line before clicking <strong> Update now</strong>.',
    UpdateOrgWarning: 'Please select at least 1 organizational information line and check "I confirm and take full responsibility for updating the citizen identification number on the organizational structure" before clicking <strong> Update now</strong>.',
    HandleOtherInvoice: 'Use software to check third-party invoices.',
    HandleOtherInvoiceSetupWarning: 'You are setting up the unit as a software user to check third-party invoices. After you select Save, this setting will be fixed and cannot be changed.',
    DeclareInfoAccuracyNote: 'Please declare information <strong>exactly according to the business license</strong>. The system will use this information to verify the legality of invoices.',
    VerifyBuyerSellerInfo: 'The system will verify buyer and seller information on invoices according to data from the Tax Authority.',
    DeclaredInfoNotUsedNote: 'The declared unit information will <strong>not be used</strong> to verify invoices.',
    ThirdPartyInvoiceSetupLocked: 'The unit has been set up to use the software to check third-party invoices. The system does not support changes to limit impact on previous invoice verification results.',
    ThirdPartyInvoiceSetupConfirmed: 'The unit has been set up to use the software to check third-party invoices.',
    CheckOwnUnitCreateNewCompany: 'If you want to check invoices for your own unit, please create a new company to do so.',
    OwnUnitInvoiceSetupLocked: 'The unit has been set up to use the software to check invoices for its own unit. The system does not support changes to limit impact on previous invoice verification results.',
    CheckThirdPartyCreateNewCompany: 'If you want to check third-party invoices, please create a new company to do so.',
    OrganizationLimitReached: maxCount => `The number of units in the organizational structure has reached the maximum limit of ${maxCount}. To add a new unit, please delete unused units.\nNote: Before deleting, you need to transfer all Invoices/Customs Declarations of that unit to another unit.`,
    CannotAddNewUnit: 'Cannot add new unit',
    CannotChangeSettings: 'Cannot change settings'
};
